import lazysizes from 'lazysizes';
import bgset from 'lazysizes/plugins/bgset/ls.bgset.min';

window.addEventListener('DOMContentLoaded', () => {
    window.lazySizesConfig = window.lazySizesConfig || {};
    window.lazySizesConfig.customMedia = { '--mobile': '(max-width: 750px)' };
});

